export default {"src":"/_next/static/media/placeholder-640x360.eace7354.svg","height":360,"width":640,"blurWidth":0,"blurHeight":0};